module.exports = __webpack_public_path__ + "static/TT-Floorplan-Floor22-2f43a32516bb9c2520818eaea383fe05.pdf";